import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
//declare function ire(string,{}): any;

@Component({
  selector: 'app-plagiarism-checker',
  templateUrl: './plagiarism-checker.component.html',
  styleUrls: ['./plagiarism-checker.component.scss']
})
export class PlagiarismCheckerComponent implements OnInit, AfterViewInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Trinka盗用・剽窃チェック｜高度で正確な盗用・剽窃チェックツール');
    this.metaTagService.updateTag({ name: 'description', content: "インターネット上の広範な情報ソースや有料の学術ジャーナルを含む刊行物で構成される最大級のデータベースが、すべての専門領域をカバー。高品質の盗用・剽窃チェックをご体験ください。" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka盗用・剽窃チェック｜高度で正確な盗用・剽窃チェックツール' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'インターネット上の広範な情報ソースや有料の学術ジャーナルを含む刊行物で構成される最大級のデータベースが、すべての専門領域をカバー。高品質の盗用・剽窃チェックをご体験ください。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/features/plagiarism-check' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/pc-check.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka盗用・剽窃チェック｜高度で正確な盗用・剽窃チェックツール' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "インターネット上の広範な情報ソースや有料の学術ジャーナルを含む刊行物で構成される最大級のデータベースが、すべての専門領域をカバー。高品質の盗用・剽窃チェックをご体験ください。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/features/pc-check.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/plagiarism-check' });
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/Mc_EZXIzvFU" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  

}
